import { ModifierItemState } from './modifier-item-reducer';
import { MODIFIER_ITEM_ACTION_TYPE, ModifierItemActions, ModifierItemPaginationParams } from './modifier-item-type';

export const modifierItemCreators = {
  setModifierItemState: <KeyName extends keyof ModifierItemState>(
    key: KeyName,
    value: ModifierItemState[KeyName]
  ): ModifierItemActions => ({
    type: MODIFIER_ITEM_ACTION_TYPE.SET_MODIFIER_ITEM_STATE,
    payload: { key, value },
  }),
  callModifierItems: (params?: ModifierItemPaginationParams) => ({
    type: MODIFIER_ITEM_ACTION_TYPE.CALL_MODIFIER_ITEMS,
    payload: params,
  }),
};
